import React, { useState, useEffect } from "react";
import "../../assets/styles/AnimatedText.css";

const AnimatedText = () => {
  const texts = [
    { title: "LEARN", desc: "the best course in Entrepreneurship" },
    { title: "GET MENTORED", desc: "by the industry’s leaders from multiple disciplines" },
    { title: "GET CERTIFIED", desc: "From Pearson & HCL, leaders in education and technology" },
    { title: "PITCH", desc: "your idea to become tomorrow’s problem solver" },
    { title: "WIN", desc: "up to 10 lakhs in grants for your        idea" },
    { title: "PRACTICE", desc: "your skills by interning with leading startups and companies" },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
   <div className="animated-text">
      <span key={texts[index].title + texts[index].desc} className="fade">
        <strong>{texts[index].title}</strong> {texts[index].desc}
      </span>
    </div>
  );
};

export default AnimatedText;
